<template>
  <div class="flex justify-start mb-3 relative">
    <div
      v-if="!isProPlan"
      class="absolute top-0 left-0 w-full h-full z-10 cursor-pointer"
      @click="handleCheckNeedUpgradeShowAccountTab()"
    ></div>
    <aha-checkbox
      v-model="presentation.isAccountTabVisible"
      class="group flex remove-css-disable"
      :disabled="!isProPlan && isBeforeCurrentPeriodStart"
      @change="toggleIsAccountTabVisible()"
    >
      <span>
        {{ $i18nPresenter.t("Show the Account tab on audience's device") }}
        <span v-if="!canUseNewTooltip">
          <IconNeedUpgradePlan
            ref="iconNeedUpgradePlanComponentShowAccountTab"
            :noPermission="!isProPlan"
            :defaultTooltip="{
              content: showAccountTabTooltip,
              html: true,
            }"
            left="-215px"
            upgradePlan="pro"
            featureName="Show/Hide Audience App Account Tab"
            v-if="planBenefit.interactivePresentation"
          />
        </span>
        <span v-else>
          <UpgradeIcon
            ref="iconNeedUpgradePlanComponentShowAccountTab"
            :noPermission="!isProPlan"
            :defaultTooltip="{
              content: showAccountTabTooltip,
              html: true,
            }"
            upgradePlan="pro"
            featureName="Show/Hide Audience App Account Tab"
            v-if="planBenefit.interactivePresentation"
          />
        </span>

      </span>
    </aha-checkbox>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Util from '@/util'
import Socket from '@/socket'

import eventCategories from '@/constant/eventCategories'

import IconNeedUpgradePlan from '@/components-v2/my-plan/IconNeedUpgradePlan.vue'
import UpgradeIcon from '@/components-v2/my-plan/UpgradeIcon.vue'

export default {
  components: {
    IconNeedUpgradePlan,
    UpgradeIcon,
  },
  props: {
    isProPlan: {
      type: Boolean,
      default: false,
    },
    isBeforeCurrentPeriodStart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ctaUpgradeHideAccountTab: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      planBenefit: (state) => state.planBenefit,
    }),
    ...mapGetters('featureToggles', ['canUseNewTooltip']),
    showAccountTabTooltip() {
      return `
        ${this.$i18nPresenter.t('If this option is unselected:')}
        <ul class="list-disc list-inside pl-2">
          <li>${this.$i18nPresenter.t('The Account tab will be hidden.')}</li>
          <li>${this.$i18nPresenter.t('No login/signup links will be shown.')}</li>
        </ul>
      `
    },
  },
  methods: {
    toggleIsAccountTabVisible() {
      const payload = {
        isAccountTabVisible: this.presentation.isAccountTabVisible,
        socketId: Socket.getSocketId(),
      }

      this.$store.dispatch('updatePresentation', payload)
      this.$emit('updatePresentation', payload)
      Util.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'click_checkbox_audience_account_tab_visibility',
        payload.isAccountTabVisible ? 'enable' : 'disable',
        null,
        {
          presentationId: this.presentation.id,
          userId: this.currentUser.id,
        },
      )
    },
    openUpgradeToggleAccountTab() {
      if (this.isProPlan) {
        return
      }

      this.ctaUpgradeHideAccountTab = true
    },
    clickOutsideHideAccountTab() {
      this.ctaUpgradeHideAccountTab = false
    },
    handleCheckNeedUpgradeShowAccountTab() {
      if (!this.isProPlan) {
        this.$refs.iconNeedUpgradePlanComponentShowAccountTab.toggleTooltip()
      }
    },
  },
}
</script>
